
import styles from "./Aboutme.module.css"

export const Aboutme = () => {

    return <div id="About me" className={styles.aboutme_outsidecontainer}>

        <div className={styles.aboutme_container}>

            <div className={styles.aboutme_details_container}>
                <div className={styles.intro}>
                    <p className={styles.aboutme_word}>About me</p>

                    <div className={styles.aboutme_details}>
                        <p>Dynamic & ambitious web developer specialized in MERN stack (MongoDB Express React Node), based in India.</p>
                        <p>I have a great interest in music and singing. Like to play guitar when I'm free. Love to travel and explore. It refreshes my mind, keeps me active all the time.</p>
                        <p>Another Engineer who loves coding and exploring new technologies.</p>
                        <p>IT experience - Worked in TCS as a Software Engineer in SAP Basis.</p>
                        <p>Connect with me on</p>
                        <a href="https://twitter.com/PratikRajuJadh2" className={styles.hover_underline_animation} target="_blank" rel="noreferrer">Twitter</a>
                        <a href="https://www.instagram.com/" className={styles.hover_underline_animation} target="_blank" rel="noreferrer">Instagram</a>
                    </div>

                </div>
                <div>
                    <img src="./Aboutme.png" alt="aboutme"></img>
                </div>
            </div>

        </div>
    </div>
}